module.exports = __webpack_public_path__ + "static/talk-1-9affab4f8bc56034f4c42f4627be14c7.png";